var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indexSlot"},[_c('nav',{staticClass:"title"},[_c('div',{staticClass:"bcGra"},[_vm._v(_vm._s(_vm.obj.bcText))]),_vm._v(" "),_c('div',{staticClass:"des"},[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),_c('span')]),_vm._v(" "),_c('section',{staticClass:"son"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31005851","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PageIndex/indexAll/components/indexSlot.vue
// module id = null
// module chunks = 